import Tooltip from "rc-tooltip";
import React, { useState } from "react";
import { Icon, Menu } from "semantic-ui-react";
import SupportModal from "./index";

const SupportModalMenuIcon = () => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Tooltip
				placement="right"
				align={{ offset: [-8, 0] }}
				mouseEnterDelay={0}
				mouseLeaveDelay={0}
				trigger="hover"
				overlay="Submit Feedback or Ticket"
			>
				<Menu.Item
					key={"supportExportModal"}
					style={{ position: "fixed", bottom: 0, height: "60px", width: "72px" }}
					active={open}
					onClick={() => {
						setOpen((prev) => !prev);
					}}
				>
					<Icon className="info circle" size="large" style={{ margin: "0px" }} />
				</Menu.Item>
			</Tooltip>
			<SupportModal open={open} setOpen={setOpen} />
		</>
	);
};

export default SupportModalMenuIcon;
